var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdminDropdowArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4167 13.1203L7.56485 8.26849C7.20687 7.9105 6.62647 7.9105 6.26849 8.26849C5.9105 8.62647 5.9105 9.20687 6.26849 9.56485L11.7685 15.0648C12.1265 15.4228 12.7069 15.4228 13.0648 15.0648L18.5648 9.56485C18.9228 9.20687 18.9228 8.62647 18.5648 8.26849C18.2069 7.9105 17.6265 7.9105 17.2685 8.26849L12.4167 13.1203Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminDropdowArr);
export default __webpack_public_path__ + "static/media/ic_admin_dropdowArr.056035d9e01ecd38c75fe7cb0de8a719.svg";
export { ForwardRef as ReactComponent };